// extracted by css-extract-rspack-plugin
export default {"reader":"Wi_r8d2q7u0TZleG","subheader":"YevD0MgEnX82WIQQ"};